// src/api/modules/ItemIncomeApi.js
import Methods from "../methods";

const searchIncomes = (context, payload) => {
  const {filters, page, size, sortBy = "registrationDate", direction = "desc"} = payload;
  const url = `api/incomes/search/?page=${page}&size=${size}&sortBy=${sortBy}&direction=${direction}`;
  return Methods.doPost(context, url, filters, null);
};

const getIncomeById = (context, id) => {
  const url = `api/incomes/${id}`;
  return Methods.doGet(context, url);
};

const saveIncome = (context, payload) => {
  const url = `api/incomes/save`;
  return Methods.doPost(context, url, payload, null);
};

const changeStatusIncome = (context, idIncome, request) => {
  const url = `api/incomes/${idIncome}/status`;
  return Methods.doPut(context, url, request, null);
};

const updateRegistrationDate = (context, payload) => {
  const url = `api/incomes/${payload.idIncome}/registration-date`;
  return Methods.doPut(context, url, payload);
};

const assignItems = (context, {incomeId, data}) => {
  const url = `api/incomes/${incomeId}/assign-items`;
  return Methods.doPost(context, url, data, null);
};

export default {
  searchIncomes,
  getIncomeById,
  saveIncome,
  changeStatusIncome,
  updateRegistrationDate,
  assignItems
};



// WEBPACK FOOTER //
// ./src/api/modules/ItemIncomeApi.js